// Firebase Configuration and Initialization
// This runs alongside existing MongoDB/JWT system
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration from Firebase Console
// REPLACE THESE VALUES WITH YOUR ACTUAL FIREBASE CONFIG
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "YOUR_API_KEY_HERE",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "your-project.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "your-project-id",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "your-project.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789012",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:123456789012:web:abcdef123456",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-XXXXXXXXXX"
};

// Initialize Firebase (only if config is valid)
let app = null;
let db = null;
let storage = null;
let analytics = null;

try {
  // Only initialize if API key is provided (not default placeholder)
  if (firebaseConfig.apiKey && !firebaseConfig.apiKey.includes('YOUR_API_KEY')) {
    app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    storage = getStorage(app);
    
    // Analytics only works in production
    if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
      analytics = getAnalytics(app);
    }
    
    console.log('✅ Firebase initialized successfully (complementary to MongoDB)');
  } else {
    console.log('ℹ️ Firebase not configured - using MongoDB only');
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
  console.log('⚠️ Firebase unavailable - falling back to MongoDB only');
}

// Export Firebase services (can be null if not configured)
export { app, db, storage, analytics };

// Helper to check if Firebase is available
export const isFirebaseAvailable = () => {
  return app !== null && db !== null;
};
